module.exports = __webpack_public_path__ + "img/three.c9bd3667.png";